import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WebsiteLayout from "./layouts/WebsiteLayout";
import HomePage from "./pages/HomePage";
import EulaPage from "./pages/EulaPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import VideoPlayer from "./components/VideoPlayer";
import DataProvider from "./context/DataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <DataProvider>
      <Routes>
        <Route path="/" element={<WebsiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="eula" element={<EulaPage />} />
          <Route path="terms-and-conditions" element={<TermsPage />} />
        </Route>
        <Route path="/video/:videoId" element={<VideoPlayer />} />
      </Routes>
    </DataProvider>
  </BrowserRouter>
);
